import { render } from "./wQuarter.vue?vue&type=template&id=b6c6ef96&ts=true"
import script from "./wQuarter.vue?vue&type=script&lang=ts"
export * from "./wQuarter.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__